/* Files go straight to R2 through scoped, expiring URLs. No storage secrets in Shopify. */
(() => {
  const MAX_FILES = 10, MAX_FILE = 2 * 1024 ** 3, MAX_TOTAL = 4 * 1024 ** 3;
  const EXT = /\.(stl|3mf|obj|step|stp|zip|rar|7z|pdf|png|jpe?g|webp)$/i;
  const sizeLabel = n => n >= 1024 ** 3 ? `${(n / 1024 ** 3).toFixed(1)} GB` : n >= 1024 ** 2 ? `${(n / 1024 ** 2).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`;
  function init(root = document) {
    root.querySelectorAll('[data-pb-quote]').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      // Only recognised service links may preselect this field. Never overwrite a restored choice.
      const projectField = form.elements.namedItem('projectType');
      const projects = new Map([
        ['miniatures', 'Miniatures or scale models'],
        ['display', 'Display piece or collectible'],
        ['batch', 'Prototype or small batch']
      ]);
      const project = projects.get(new URLSearchParams(window.location.search).get('project'));
      if (project && projectField && !projectField.value) projectField.value = project;
      const get = key => form.querySelector(`[data-${key}]`);
      const button = get('quote-submit'), fields = get('quote-fields'), error = get('quote-error'), success = get('quote-success'), status = get('quote-status');
      const input = get('upload-input'), list = get('upload-list'), drop = get('upload-drop'), fileError = get('upload-error'), progress = get('upload-progress'), progressWrap = get('upload-progress-wrap'), progressLabel = get('upload-progress-label'), stop = get('upload-stop');
      let selected = [], plans = null, pending = false, finished = false, requestId = null, controller = null, uploadLocked = false;
      const completedParts = new Map(), receipts = new Map();
      const clear = get('upload-clear');
      clear.addEventListener('click', () => { if (pending || uploadLocked) return; selected = []; fileError.hidden = true; renderFiles(); });
      function renderFiles() {
        list.replaceChildren();
        selected.forEach((file, index) => {
          const row = document.createElement('li'), text = document.createElement('span');
          text.textContent = `${file.name} · ${sizeLabel(file.size)}${receipts.has(index) ? ' · Uploaded' : ''}`;
          row.append(text);
          if (!uploadLocked) {
            const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = 'Remove'; remove.setAttribute('aria-label', `Remove ${file.name}`);
            remove.addEventListener('click', () => { selected.splice(index, 1); fileError.hidden = true; renderFiles(); }); row.append(remove);
          }
          list.append(row);
        });
        input.disabled = uploadLocked || finished;
        clear.hidden = uploadLocked || (!selected.length && fileError.hidden);
      }
      function addFiles(files) {
        if (pending || uploadLocked || finished) return;
        fileError.hidden = true;
        const next = [...selected];
        for (const file of files) if (!next.some(f => f.name === file.name && f.size === file.size && f.lastModified === file.lastModified)) next.push(file);
        let message = '';
        if (next.length > MAX_FILES) message = 'Choose up to 10 files.';
        else if (next.some(f => !EXT.test(f.name) || f.name.length > 180 || /[\x00-\x1f\x7f/\\]/.test(f.name))) message = 'Choose supported model, archive, image or PDF files with names under 180 characters.';
        else if (next.some(f => f.size <= 0 || f.size > MAX_FILE)) message = 'Each file must be non-empty and no larger than 2 GB.';
        else if (next.reduce((sum, f) => sum + f.size, 0) > MAX_TOTAL) message = 'Your files exceed the 4 GB total limit.';
        if (message) { fileError.textContent = message; fileError.hidden = false; clear.hidden = false; }
        else { selected = next; renderFiles(); }
        input.value = '';
      }
      input.addEventListener('change', () => addFiles(Array.from(input.files || [])));
      ['dragenter', 'dragover'].forEach(type => drop.addEventListener(type, event => { event.preventDefault(); if (!uploadLocked) drop.classList.add('is-dragging'); }));
      ['dragleave', 'drop'].forEach(type => drop.addEventListener(type, event => { event.preventDefault(); drop.classList.remove('is-dragging'); }));
      drop.addEventListener('drop', event => addFiles(Array.from(event.dataTransfer?.files || [])));
      stop.addEventListener('click', () => controller?.abort());
      async function api(url, payload) {
        const timeout = new AbortController();
        const abort = () => timeout.abort();
        controller.signal.addEventListener('abort', abort, {once: true});
        const timer = setTimeout(abort, 55000);
        try {
          if (controller.signal.aborted) throw new DOMException('Stopped', 'AbortError');
          const response = await fetch(url, {method: 'POST', mode: 'cors', credentials: 'omit', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(payload), signal: timeout.signal});
          const result = await response.json().catch(() => null);
          if (!response.ok || result?.ok !== true) throw new Error(result?.error || 'We could not confirm your enquiry. Please retry with the same details.');
          return result;
        } finally { clearTimeout(timer); controller.signal.removeEventListener('abort', abort); }
      }
      function putPart(url, blob, onProgress) {
        return new Promise((resolve, reject) => {
          const target = new URL(url);
          if (target.protocol !== 'https:' || !target.hostname.endsWith('.r2.cloudflarestorage.com')) return reject(new Error('The storage connection is not configured correctly.'));
          const xhr = new XMLHttpRequest();
          const abort = () => xhr.abort();
          const finish = failure => { controller.signal.removeEventListener('abort', abort); failure ? reject(failure) : resolve(); };
          xhr.open('PUT', url); xhr.timeout = 10 * 60 * 1000;
          xhr.upload.onprogress = event => { if (event.lengthComputable) onProgress(event.loaded); };
          xhr.onload = () => finish(xhr.status >= 200 && xhr.status < 300 ? null : new Error('A file part could not be uploaded. Keep this page open and retry.'));
          xhr.onerror = () => finish(new Error('The file transfer could not reach Cloudflare storage. Keep this page open and retry, or contact us.'));
          xhr.ontimeout = () => finish(new Error('A file transfer timed out. Keep this page open and retry.'));
          xhr.onabort = () => finish(new DOMException('Stopped', 'AbortError'));
          if (controller.signal.aborted) return reject(new DOMException('Stopped', 'AbortError'));
          controller.signal.addEventListener('abort', abort, {once: true});
          // The browser sets Content-Length from this Blob. That exact size is signed.
          xhr.send(blob);
        });
      }
      async function uploadFiles(endpoint, payload) {
        if (!selected.length) return [];
        const uploadUrl = endpoint.href.replace(/\/$/, '') + '/uploads';
        progressWrap.hidden = false; stop.hidden = false; get('upload-note').hidden = false;
        status.textContent = 'Preparing your files…';
        if (!plans) {
          const result = await api(uploadUrl, {action: 'start', requestId, email: payload.email, website: payload.website, files: selected.map(f => ({name: f.name, size: f.size}))});
          if (!Array.isArray(result.plans) || result.plans.length !== selected.length) throw new Error('The upload could not be prepared. Please retry.');
          for (const plan of result.plans) if (!plan.token || !Number.isSafeInteger(plan.partSize) || plan.partSize <= 0 || !Array.isArray(plan.urls)) throw new Error('Invalid upload configuration. Please contact us.');
          plans = result.plans; uploadLocked = true; renderFiles();
        }
        const total = selected.reduce((sum, f) => sum + f.size, 0);
        let done = 0;
        function update(current, label) {
          const percent = Math.min(100, Math.floor((done + current) / total * 100));
          progress.value = percent; progress.textContent = `${percent}%`; progressLabel.textContent = `${label} · ${percent}%`;
        }
        for (let index = 0; index < selected.length; index++) {
          const file = selected[index], plan = plans[index];
          if (receipts.has(index)) { done += file.size; update(0, 'Files uploaded'); continue; }
          if (Date.now() >= plan.expires) throw new Error('The upload session expired. Copy your project details, then reload and choose your files again.');
          for (let part = 0; part < plan.urls.length; part++) {
            const partKey = `${index}:${part}`, blob = file.slice(part * plan.partSize, Math.min(file.size, (part + 1) * plan.partSize));
            if (!completedParts.has(partKey)) {
              status.textContent = `Uploading file ${index + 1} of ${selected.length}: ${file.name}`;
              await putPart(plan.urls[part].url, blob, loaded => update(loaded, `Uploading ${index + 1} of ${selected.length}`));
              completedParts.set(partKey, true);
            }
            done += blob.size; update(0, `Uploading ${index + 1} of ${selected.length}`);
          }
          status.textContent = `Checking file ${index + 1} of ${selected.length}…`;
          const result = await api(uploadUrl, {action: 'complete', requestId, token: plan.token});
          if (typeof result.receipt !== 'string' || !result.receipt) throw new Error('The upload was not confirmed. Please retry.');
          receipts.set(index, result.receipt); renderFiles();
        }
        stop.hidden = true; return selected.map((_, index) => receipts.get(index));
      }
      button.disabled = false;
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (pending || finished || !form.reportValidity() || !fileError.hidden) return;
        error.hidden = true; fileError.hidden = true;
        const values = new FormData(form);
        const payload = Object.fromEntries(['name', 'email', 'service', 'projectType', 'quantity', 'modelUrl', 'projectNotes', 'website'].map(key => [key, String(values.get(key) || '').trim()]));
        payload.source = window.location.origin + window.location.pathname;
        pending = true; fields.disabled = true; button.disabled = true; form.setAttribute('aria-busy', 'true'); controller = new AbortController();
        try {
          const endpoint = new URL(form.dataset.endpoint);
          if (endpoint.protocol !== 'https:' || endpoint.username || endpoint.password || endpoint.search || endpoint.hash) throw new Error('The enquiry connection is not configured. Please email us below.');
          if (!requestId) requestId = crypto.randomUUID();
          const uploadReceipts = await uploadFiles(endpoint, payload);
          status.textContent = 'Saving your enquiry…';
          const result = await api(endpoint.href, {...payload, requestId, uploadReceipts});
          if (typeof result.submissionId !== 'string' || !result.submissionId) throw new Error('We could not confirm your enquiry. Please retry with the same details.');
          finished = true; get('quote-reference').textContent = result.submissionId; fields.hidden = true; success.hidden = false; status.textContent = ''; success.focus();
        } catch (err) {
          error.textContent = controller.signal.aborted ? 'Upload stopped. Your files and details are still here. Click Request my quote to resume.' : err instanceof TypeError || err?.name === 'AbortError' ? 'We could not confirm your enquiry. Keep this page open and retry with the same details, or email info@printbrothersco.com.' : err.message || 'Something went wrong. Please retry or email us.';
          error.hidden = false; status.textContent = ''; error.focus();
        } finally {
          pending = false; fields.disabled = finished; button.disabled = finished; stop.hidden = true; input.disabled = uploadLocked || finished; form.removeAttribute('aria-busy');
        }
      });
    });
  }
  if (!window.pbQuoteInitialiser) {
    window.pbQuoteInitialiser = init;
    document.addEventListener('shopify:section:load', event => init(event.target));
  }
  init();
})();
